import type { VfConfig } from '#types/config/components/vf'

export default {
  brandClasses: {
    controls: 'absolute z-2 flex bg-white/50',
    controlsInactive: '!op-0'
  }
} satisfies VfConfig['carousel']
